export const SCHEDULE_FILTERS_STORAGE_KEY = "generalScheduleFilters";
/** label - значения интерфейса / value - точные значения вместе с сиволами и пробелами от 1С */
export const howDidLearnOptions = [
  { label: "Блогеры", value: "Блогеры" },
  { label: "Живу рядом (вывеска клиники)", value: "Живу рядом (вывеска клиники)" },
  { label: "Интернет (Поиск: Яндекс, Гугл)", value: "Интернет (Поиск:Яндекс, Гугл)" },
  { label: "Карты (Яндекс, Гугл, 2ГИС)", value: "Карты (Яндекс, Гугл, 2ГИС)" },
  { label: "На поправку", value: "На поправку" },
  { label: "Направление врача", value: "Направление врача" },
  { label: "Наружная реклама (не у клиники)", value: "Наружная реклама (не у клиники)" },
  { label: "Повторный визит в клинику", value: "Повторный визит в клинику" },
  { label: "Радио", value: "Радио" },
  { label: "Рекомендации докторов других клиник", value: "Рекомендации докторов других клиник" },
  { label: "Рекомендации докторов НАШИХ клиник", value: "Рекомендации докторов НАШИХ клиник" },
  { label: "Рекомендации знакомых", value: "Рекомендации знакомых" },
  { label: "Сайт Про Докторов", value: "Сайт Про Докторов" },
  { label: "СберЗдоровье", value: "СберЗдоровье" },
  { label: "Соц.сети", value: "Соц.сети" },
  { label: "Телевидение", value: "Телевидение" },
  { label: "Техническая запись", value: "Техническая запись" },
  { label: "Другое", value: "Другое" }
];
// ToDo на данный момент нет данной сущности на бекенде
export const visitFormatOptions = [
  {
    value: "online",
    label: "Онлайн"
  },
  {
    value: "clinic",
    label: "В клинике"
  },
  {
    value: "chat",
    label: "Чат"
  },
  {
    value: "home_visit",
    label: "Выезд на дом"
  }
];
// ToDo перепроверить value, ранее были другие: PAID DMS OMS
export const paymentTypeOptions = ["Платные", "ДМС", "ОМС"].map(option => ({
  label: option,
  value: option
}));
// ToDo перепроверить value, ранее были другие: sms email whats_app
export const notificationTypeOptions = ["СМС", "Email", "WhatsApp"].map(option => ({
  label: option,
  value: option
}));
export const entrySourceOptions = [
  "Сайт",
  "МИС",
  "Входящий телефонный звонок",
  "Исходящий телефонный звонок",
  "Чат",
  "Личное обращение в клинику",
  "Прочее",
  "Инстаграмм",
  "Врачи (Ася)",
  "Про докторов",
  "СберЗдоровье",
  "Мобильное приложение",
  "На поправку",
  "Чатбот"
].map(option => ({
  label: option,
  value: option
}));
